import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Kiosks_Object} state
 *  @property {object} model
 *  @property {Kiosks_Properties} model.properties
 *  @property {Kiosks_Is} model.is
 *  @property {Kiosks_Has} model.has
 */
class KioskObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Kiosks._name);
	}

	form = () => {
		/** @type {Kiosks_Properties} properties */
		let properties = this.model.properties;
		/** @type {Kiosks_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"Kiosk Name"}
							value={object.name}
							error={object.name_error}
							property={properties.name}
							update={this.handleTextFieldPropertyUpdate}
						/>
					</div>
					<div className="form-group">
						<Parts.SelectLocation
							object={object}
							properties={properties}
							shouldLoad={this.state.loaded}
							onSelectUpdate={this.handleSelectPropertyUpdate}
							locations={this.props.locations}
							states={this.props.states}
							filter={this.filterLocationOptions}
						/>
					</div>

				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

}

export default Framework.Components.withRootState(KioskObject);
